export const actionTypes = {
  MAIL_REQUEST: "MAIL_REQUEST",
  MAIL_REQUEST_SUCCESS: "MAIL_REQUEST_SUCCESS",
  MAIL_REQUEST_FAILURE: "MAIL_REQUEST_FAILURE",
  MAIL_DETAIL_REQUEST: "MAIL_DETAIL_REQUEST",
  CREATE_TEMPLATE_MAIL: "CREATE_TEMPLATE_MAIL",
  CREATE_TEMPLATE_MAIL_SUCCESS: "CREATE_TEMPLATE_MAIL_SUCCESS",
  CREATE_TEMPLATE_MAIL_FAILURE: "CREATE_TEMPLATE_MAIL_FAILURE",
  MODIFY_TEMPLATE_MAIL: "MODIFY_TEMPLATE_MAIL",
  MODIFY_TEMPLATE_MAIL_SUCCESS: "MODIFY_TEMPLATE_MAIL_SUCCESS",
  MODIFY_TEMPLATE_MAIL_FAILURE: "MODIFY_TEMPLATE_MAIL_FAILURE",
  DELETE_TEMPLATE_MAIL: "DELETE_TEMPLATE_MAIL",
  DELETE_TEMPLATE_MAIL_SUCCESS: "DELETE_TEMPLATE_MAIL_SUCCESS",
  DELETE_TEMPLATE_MAIL_FAILURE: "DELETE_TEMPLATE_MAIL_FAILURE",
  RESET_STATE_TEMPLATE_MAIL_MANAGEMENT: "RESET_STATE_TEMPLATE_MAIL_MANAGEMENT",
  RESET_MAIL_DETAIL: "RESET_MAIL_DETAIL",
};

export const mailRequest = () => ({
  type: actionTypes.MAIL_REQUEST,
});

export const mailRequestSuccess = (payload: string[]) => ({
  type: actionTypes.MAIL_REQUEST_SUCCESS,
  payload,
});

export const mailRequestFailure = (err: Error) => ({
  type: actionTypes.MAIL_REQUEST_FAILURE,
  err,
});

export const mailDetailRequest = (payload: any) => ({
  type: actionTypes.MAIL_DETAIL_REQUEST,
  payload,
});

export const resetMailDetail = () => ({
  type: actionTypes.RESET_MAIL_DETAIL,
});

export const createTemplateMail = (payload: any[]) => ({
  type: actionTypes.CREATE_TEMPLATE_MAIL,
  payload,
});

export const createTemplateMailSuccess = (payload: any[]) => ({
  type: actionTypes.CREATE_TEMPLATE_MAIL_SUCCESS,
  payload,
});

export const createTemplateMailFailure = (err: Error) => ({
  type: actionTypes.CREATE_TEMPLATE_MAIL_FAILURE,
  err,
});

export const modifyTemplateMail = (payload: any[]) => ({
  type: actionTypes.MODIFY_TEMPLATE_MAIL,
  payload,
});

export const modifyTemplateMailSuccess = (payload: any[]) => ({
  type: actionTypes.MODIFY_TEMPLATE_MAIL_SUCCESS,
  payload,
});

export const modifyTemplateMailFailure = (err: Error) => ({
  type: actionTypes.MODIFY_TEMPLATE_MAIL_FAILURE,
  err,
});

export const deleteTemplateMail = (id: number) => ({
  type: actionTypes.DELETE_TEMPLATE_MAIL,
  id,
});

export const deleteTemplateMailSuccess = (payload: any) => ({
  type: actionTypes.DELETE_TEMPLATE_MAIL_SUCCESS,
  payload,
});

export const deleteTemplateMailFailure = (err: Error) => ({
  type: actionTypes.DELETE_TEMPLATE_MAIL_FAILURE,
  err,
});

//RESET

export const resetState = () => ({
  type: actionTypes.RESET_STATE_TEMPLATE_MAIL_MANAGEMENT,
});
